var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTech(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 511.991 511.991",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.143 170.485h-24.1c-8.284 0-15 6.716-15 15s6.716 15 15 15h24.1c19.869-.732 19.876-29.265 0-30zM497.043 170.485h-24.1c-8.284 0-15 6.716-15 15s6.716 15 15 15h24.1c19.87-.732 19.876-29.265 0-30zM92.065 42.719c14.566 13.532 34.75-6.638 21.213-21.213L96.239 4.467c-5.857-5.857-15.355-5.857-21.213 0s-5.858 15.355 0 21.213zM420.022 328.251c-14.567-13.531-34.749 6.639-21.213 21.213l17.039 17.039c5.856 5.856 15.353 5.86 21.213 0 5.858-5.857 5.858-15.355 0-21.213zM92.065 328.251 75.026 345.29c-5.858 5.857-5.858 15.355 0 21.213 5.856 5.856 15.353 5.86 21.213 0l17.039-17.039c13.533-14.567-6.64-34.748-21.213-21.213zM415.848 4.467l-17.039 17.039c-5.858 5.857-5.858 15.355 0 21.213 5.856 5.856 15.353 5.86 21.213 0l17.039-17.039c13.533-14.567-6.639-34.747-21.213-21.213zM326.523 200.485l-28.289 28.289c15.771 30.505-7.694 68.572-42.192 68.111-25.989 0-47.133-21.143-47.133-47.133-.458-34.495 37.607-57.965 68.112-42.191l32.682-32.683a14.998 14.998 0 0 1 10.606-4.394h102.688c-23.246-202.181-310.738-202.033-333.91 0h96.476l28.289-28.289c-15.771-30.504 7.694-68.572 42.192-68.111 25.989 0 47.133 21.144 47.133 47.133.458 34.495-37.607 57.965-68.112 42.19l-32.682 32.683a14.998 14.998 0 0 1-10.606 4.394H89.098c3.781 41.903 23.278 80.992 54.821 109.005 17.178 15.879 28.321 37.216 31.737 60.12.037-.005 160.718-.005 160.774 0 3.414-22.899 14.558-44.239 31.738-60.12 31.543-28.012 51.041-67.102 54.821-109.005h-96.466zM176.777 416.741c0 38.579 27.709 70.791 64.267 77.824-1.491 23.241 31.497 23.227 30 0 36.558-7.033 64.267-39.245 64.267-77.824v-17.134H176.777z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.177 121.219c0-9.447-7.687-17.134-17.134-17.134-22.699.862-22.693 33.409 0 34.268 9.447-.001 17.134-7.687 17.134-17.134zM238.909 249.752c0 9.447 7.687 17.134 17.134 17.134 22.699-.862 22.693-33.409 0-34.267-9.447 0-17.134 7.686-17.134 17.133z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTech);
export default __webpack_public_path__ + "static/media/Tech.a2f182a60e3855d95af8f3457bbdd801.svg";
export { ForwardRef as ReactComponent };